import React from 'react';

import { Text } from '@change/ds-core-ui/next';

import { TranslatePlural } from '@change-corgi/core/react/i18n';

type Props = {
	percentage: number;
};

export const VotersInfo: React.FC<Props> = ({ percentage }) => {
	const roundedPercentage = Math.round(percentage * 100);

	return (
		<div className="flex items-center gap-2">
			<Text>
				{/* TODO: how do we handle languages that have a space between value and % */}
				<Text className="font-bold">{roundedPercentage}%&nbsp;</Text>
				<TranslatePlural value="corgi.petition_gamma.content_summary.voters.label" count={roundedPercentage} />
			</Text>
		</div>
	);
};
